import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types"
import * as PersonActions from "../../reducers/person";
import {Card, Col, Row} from "antd"
import {DetailsTitle, StatusIndication, TextAligned} from "../../util/Util";
import SiteTable from "../site/SiteTable";
import ModalExport from "./Modal"
import PersonCustomerSelectionTable from "./PersonCustomerSelectionTable";

class PersonDetails extends React.Component {

    static propTypes = {
        getPerson: PropTypes.func.isRequired,
        person: PropTypes.object.isRequired,
        fetchingSingle: PropTypes.bool.isRequired
    };

    componentDidMount() {
        const {match, getPerson } = this.props;
        console.log('match: ', match)
        const isMdm = match.path.indexOf('/person/mdm') > -1;
        console.log('isMdm', isMdm)
        const urlId = match.params.id;
        getPerson(urlId, isMdm);
    }

    state = {
        visible: false,
        confirmLoading: false,
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = () => {
        this.setState({
            confirmLoading: true,
        });
        setTimeout(() => {
            this.setState({
                visible: false,
                confirmLoading: false,
            });
        }, 2000);
    };

    handleCancel = () => {
        console.log('Clicked cancel button');
        this.setState({
            visible: false,
        });
    };

    render() {
        const {fetchingSingle} = this.props;
        const { visible, confirmLoading } = this.state;
        const {person, sites, educations, kol, personCustomerSelection} = this.props.person;

        return <Card title={<DetailsTitle icon="user">{person.firstName || ''} {person.lastName || ''}</DetailsTitle>}
                     loading={fetchingSingle}>
            <Row gutter={20}>
                <Col span={5}>
                    <TextAligned label="First Name" value={person.firstName}/>
                    <TextAligned label="Last Name" value={person.lastName}/>
                    <TextAligned label="Person Type" value={person.persType}/>
                    <TextAligned label="Status" value={<StatusIndication active={person.active}/>}/>
                    <br/>
                    <TextAligned label="Title" value={person.title}/>
                    <TextAligned label="Gender" value={person.gender}/>
                    <TextAligned label="Official ID" value={person.officialId}/>
                    <TextAligned label="Country" value={person.country}/>
                    <TextAligned label="Number of Affiliations" value={sites.length}/>
                    <br/>
                    <TextAligned label="Source" value={person.source}/>
                    <TextAligned label="Created" value={person.ct}/>
                    <TextAligned label="Updated" value={person.ut}/>
                    <TextAligned label="Validated" value={person.vt}/>
                    <TextAligned label="Person ID" value={person.id}/>
                    <TextAligned label="aPureBase ID" value={person.apurebaseId}/>
                    <TextAligned label="Merged to" value={person.merge}/>
                </Col>
                <Col span={4}>

                    <Card title="Education Specialties">
                        {educations.map(edu => <p key={edu}>{edu}</p>)}
                    </Card>

                    <Card title="Person KOL">
                        {kol.map(k => <p key={k}>{k}</p>)}
                    </Card>
                </Col>
                <Col span={15}>
                    <PersonCustomerSelectionTable dataSource={personCustomerSelection} loading={false} />
                    <SiteTable dataSource={sites} loading={false}/>
                </Col>
            </Row>
        <ModalExport showModal={this.showModal} visible={visible} handleOk={this.handleOk} confirmLoading={confirmLoading} handleCancel={this.handleCancel} person={person}  />
        </Card>

    }
}

PersonDetails.propTypes = {
    download: PropTypes.func.isRequired,
    downloading: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    person: state.person.person,
    fetchingSingle: state.person.fetchingSingle
});

const mapDispatchToProps = dispatch => ({
    getPerson: bindActionCreators(PersonActions, dispatch).getPerson
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonDetails)



// WEBPACK FOOTER //
// ./src/js/browse/person/PersonDetails.js